import { useRouter } from "next/router";
import { useShallow } from "zustand/react/shallow";
import { mapFiltersToUrl } from "../../utils";
import { useSearchStore } from "../use-search-store/use-search-store";
const getUrlForPageNumber = (page, filters, queryParams, allCinchStores)=>{
    const [urlPart, searchParamsPart] = mapFiltersToUrl(filters, allCinchStores, new URLSearchParams(queryParams)).split("?");
    const searchParams = new URLSearchParams(searchParamsPart);
    if (page === 1) {
        searchParams.delete("pageNumber");
    } else {
        searchParams.set("pageNumber", `${page}`);
    }
    if ([
        ...searchParams.values()
    ].length > 0) {
        return `${urlPart}?${searchParams}`;
    }
    return urlPart;
};
export function useSearchFilters() {
    const primaryFilters = useSearchStore(useShallow((state)=>({
            bodyType: state.bodyType,
            colour: state.colour,
            doors: state.doors,
            driveType: state.driveType,
            features: state.features,
            fromEngineSize: state.fromEngineSize,
            fromPrice: state.fromPrice,
            fromYear: state.fromYear,
            fuelType: state.fuelType,
            gearbox: state.gearbox,
            make: state.make,
            mileage: state.mileage,
            model: state.model,
            seats: state.seats,
            store: state.store,
            tags: state.tags,
            toEngineSize: state.toEngineSize,
            toPrice: state.toPrice,
            toYear: state.toYear,
            trim: state.trim
        })));
    const auxFilters = useSearchStore(useShallow((state)=>({
            pageNumber: state.pageNumber,
            pageSize: state.pageSize,
            sortingCriteria: state.sortingCriteria,
            useMonthly: state.useMonthly
        })));
    const filters = Object.assign({}, primaryFilters, auxFilters);
    const functions = useSearchStore(useShallow((state)=>({
            updateFilter: state.updateFilter,
            updateFilters: state.updateFilters,
            clearFilterValue: state.clearFilterValue,
            clearAllFilters: state.clearAllFilters,
            setPageNumber: state.setPageNumber,
            setPageSize: state.setPageSize,
            setSortingCriteria: state.setSortingCriteria,
            setUseMonthly: state.setUseMonthly
        })));
    const { allCinchStores  } = useSearchStore(useShallow((state)=>({
            allCinchStores: state.allCinchStoresLowercase
        })));
    const totalFilterCount = Object.values(primaryFilters).reduce((currentCount, filter)=>currentCount + filter.length, 0);
    const { pathSegmentFilters  } = useSearchStore(useShallow((state)=>({
            pathSegmentFilters: state.pathSegmentFilters
        })));
    const router = useRouter();
    const queryParams = router.asPath.split("?")[1] ?? "";
    return {
        ...functions,
        ...auxFilters,
        params: filters,
        filters: primaryFilters,
        totalFilterCount,
        pathSegmentFilters,
        getUrlForPageNumber: (page)=>getUrlForPageNumber(page, filters, queryParams, allCinchStores)
    };
}
